import api from '../../../services/api';

const API_URL = '/api/v1/manager/utilities';

/**
 * @returns {Promise<ApiManager.SymbolicPeriodsResponse>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getAllMySymbolicPeriods = () => api.get(`${API_URL}/SymbolicPeriod`);
